import React from 'react';
import SignaturePreview from './SignaturePreview';
import './SignaturePreviewModal.css';

function SignaturePreviewModal({ isOpen, signature, onClose }) {
    if (!isOpen || !signature) return null;

    const handleOverlayClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="signature-preview-modal-overlay" onClick={handleOverlayClick}>
            <div className="signature-preview-modal-content">
                <div className="signature-preview-modal-header">
                    <div>
                        <h2>Aperçu de la signature</h2>
                        <p className="signature-preview-modal-subtitle">
                            {signature.name}
                        </p>
                    </div>
                    <button className="signature-preview-modal-close" onClick={onClose}>
                        <svg
                            width="24"
                            height="24"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M6 18L18 6M6 6l12 12"
                            />
                        </svg>
                    </button>
                </div>

                <div className="signature-preview-modal-body">
                    <SignaturePreview
                        gridData={signature.grid_data}
                        containerWidth={signature.container_width || 600}
                        scale={1}
                    />
                </div>

                <div className="signature-preview-modal-footer">
                    <button className="signature-preview-close-btn" onClick={onClose}>
                        Fermer
                    </button>
                </div>
            </div>
        </div>
    );
}

export default SignaturePreviewModal;
